<template>
  <el-row class="footer">
    <el-col :span="24">
      <div class="footer-content">
        <span>© 2023 Liveo Group. All Rights Reserved. Privacy. Terms of Service.</span>
        <el-menu mode="horizontal" class="footer-menu">
          <el-menu-item index="home">
            <router-link to="/home">Home</router-link>
          </el-menu-item>
          <el-menu-item index="news">
            <router-link to="/news">News</router-link>
          </el-menu-item>
          <el-menu-item index="services">
            <router-link to="/services">Services</router-link>
          </el-menu-item>
          <el-menu-item index="guides">
            <router-link to="/guides">Guides</router-link>
          </el-menu-item>
          <el-menu-item index="about">
            <router-link to="/about">about</router-link>
          </el-menu-item>
        </el-menu>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  padding: 40px 10vw;
  text-align: center;}

.footer-content {

  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 内容左右两端对齐 */
  align-items: center; /* 垂直居中对齐 */
  flex-wrap: wrap; /* 允许内容在空间不足时换行 */

  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.footer-content span {
  color: #666;
  margin-right: 20px; /* 增加右侧间距，避免和链接紧贴 */
  margin-bottom: 10px; /* 增加下边距，处理换行情况 */
}

.footer-menu {
  border-bottom: none !important; /*移除底部边框*/
  background-color: transparent !important; /* 移除菜单背景色 */
  padding: 0; /* 移除菜单内边距 */
  margin-top: 0; /* 移除菜单上边距，避免间距过大 */
}

.footer-menu .el-menu-item {
  color: #666;
  padding: 0 10px; /* 调整菜单项的内边距 */
  border: none; /* 移除边框 */
}

.footer-menu .el-menu-item:hover,
.footer-menu .el-menu-item:focus {
  background-color: transparent !important; /* 移除hover和focus时的背景色 */
  outline: none; /* 移除轮廓线 */
  text-decoration: none; /* 确保没有下划线等 */
}

.footer-menu .el-menu-item a {
  text-decoration: none; /* 移除链接下划线 */
  color: inherit; /* 链接颜色继承父元素颜色 */
}

/* 调整router-link的样式，确保其行为更像普通文本 */
.footer-menu .el-menu-item a:hover,
.footer-menu .el-menu-item a:focus {
  text-decoration: none;
  outline: none;
}
</style>
